import "./App.css";
// import 'whatwg-fetch'
// import 'es6-promise'
import React, { useState, useEffect, useMemo } from "react";
import { Result } from "antd";
import { RightOutlined } from "@ant-design/icons";
import axios from "axios";
import language from "./language";

function App() {
  console.log("国际版");
  const [states, setStates] = useState({ appName: "", versions: [], lang: "" });
  const [flag, setFlag] = useState(false);
  const [labels, setLabels] = useState({
    privacy_history: "",
    app_history: "",
    app_version: "",
  });
  const getValue = (name) => {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let res = window.location.search.substr(1).match(reg);
    return res && res[2];
  };
  const isGlobal = useMemo(() => {
    return window.location.host.indexOf("global") !== -1;
  }, []);
  const getRequesturl = (appName, lang) => {
    // 区分测试环境-正式环境与国际版-国内版
    if (process.env.NODE_ENV === "development") {
      return isGlobal
        ? `https://staging-global.privacy.mi.com/privacy-platform-open/api/product/versions/${appName}/${lang}`
        : `http://staging.privacy.mi.com/privacy-platform-open/api/product/versions/${appName}/${lang}`;
    }
    return isGlobal
      ? `https://global.privacy.mi.com/privacy-platform-open/api/product/versions/${appName}/${lang}`
      : `https://privacy.mi.com/privacy-platform-open/api/product/versions/${appName}/${lang}`;
  };

  const versionZeroDec = `1. 更新联系方式；
  2. 更新小米及第三方信息收集情况；
  3. 更加清楚阐述我们如何使用非个人信息；
  4. 更新个人信息使用情况，包括详述基于正当权益，推送服务相关个人信息的处理；
  5. 补充信息保留政策细节；
  6. 更加清楚阐述您对您的个人信息享有的权利。`;

  // axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
  // axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';

  useEffect(() => {
    // 可选增强：若来源页(referrer)的语言与当前 lang 不一致，则跟随来源页语言（保留原有行为）。
    // 注意：主流程绝不能依赖 referrer，否则地址栏直接访问 / 手机端 WebView 无 referrer 时会白屏。
    const ref = document.referrer; // 前一条地址
    if (ref) {
      try {
        const refLang = new URL(ref).pathname.split("/").pop(); // 取出如 zh_CN
        const cur = new URL(window.location.href);
        const curLang = cur.searchParams.get("lang");
        if (refLang && refLang !== curLang) {
          // 不一致才换，换完 replace 重新加载，本 effect 会再次执行并走下面主流程
          cur.searchParams.set("lang", refLang);
          window.location.replace(cur.toString()); // 跳转
          return; // 中断，等待重新加载
        }
      } catch (e) {
        // referrer 不是合法 URL，忽略，继续走主流程
      }
    }

    // 主流程：无论有无 referrer 都执行——读取参数、请求接口、渲染
    const app_Name = getValue("appName");
    const lang = getValue("lang") || "zh_CN"; // 获取语言参数
    const { privacy_history, version, history_version, title } =
      language[lang] || language["zh_CN"];
    setLabels(() => ({
      privacy_history,
      app_history: history_version,
      app_version: version,
    }));
    document.title = title;
    const url = getRequesturl(app_Name, lang);
    if (app_Name) {
      axios
        .get(url)
        .then((res) => {
          const update = {
            appName: res.data.product_name,
            versions: res.data.versions,
          };
          setStates((prev) => ({ ...prev, ...update, lang: lang }));
          setFlag(false);
        })
        .catch((err) => {
          setFlag(true);
        });
    } else {
      setFlag(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToVersion = (version) => {
    if (process.env.NODE_ENV === "development") {
      window.location.href = isGlobal
        ? `https://staging-global.privacy.mi.com/${states.appName}/v${version}/${states.lang}`
        : `http://staging.privacy.mi.com/${states.appName}/v${version}/${states.lang}`;
    } else {
      window.location.href = isGlobal
        ? `https://global.privacy.mi.com/${states.appName}/v${version}/${states.lang}`
        : `https://privacy.mi.com/${states.appName}/v${version}/${states.lang}`;
    }
  };
  return (
    <div className="markdown-post-container">
      {flag ? (
        <Result
          status="404"
          title={<span className="black">404 Not Found</span>}
          subTitle={
            !isGlobal ? (
              <span className="black">当前页面或资源不存在</span>
            ) : (
              <></>
            )
          }
          className="result-container"
        />
      ) : (
        <>
          <h1 className="markdown-post-title">
            {states.appName
              ? states.appName === "all"
                ? labels.privacy_history
                : labels.app_history
              : ""}
          </h1>
          <ul style={{ margin: 0 }}>
            {states.versions.length > 0 &&
              states.versions.map((v, index) => {
                return (
                  <li
                    style={{ listStyleType: "none", cursor: "pointer" }}
                    key={index}
                    onClick={() => goToVersion(v.version)}
                  >
                    {v.version ? (
                      <>
                        <h3 className="markdown-post-version">{`${labels.app_version}：v${v.version}`}</h3>
                        <div
                          className="markdown-post-version-container"
                          style={{
                            position: "relative",
                            top:
                              v.versionDec ||
                              (states.appName === "all" && v.version === "0")
                                ? null
                                : "-30px",
                          }}
                        >
                          {states.appName === "all" &&
                          v.version.toString() === "0" ? (
                            <p className="desc">{versionZeroDec}</p>
                          ) : (
                            <p className="desc">{v.versionDec}</p>
                          )}
                          <RightOutlined className="rightArrow" />
                        </div>
                      </>
                    ) : null}
                  </li>
                );
              })}
          </ul>
        </>
      )}
    </div>
  );
}

export default App;
